"use strict";
/**
 * Выбирает объект из списка с помощью установки переключателя.
 *
 * @event WebAccess.components.wrappers.objectList.ObjectList#onSelect 
 * @param {WebAccess.components.wrappers.objectList.ListItem} item Объект списка-переключатель, который был установлен в текущий момент
 * @param {WebAccess.components.wrappers.objectList.ListItem[]} checkedItems Все выбранные объекты списка
 * @example
 *
 *   WA.current.objectList.bind('onSelect', function (last, allItems) {
 *       
 *      console.log(last.name); //Вернет имя выбранного элемента в списке.
 * 
 *      //Вернет имена всех выделенных в текущий момент элементов в списке.
 *      for (var i =0; i < allItems.length; i++) {
 *        console.log(allItems[i].name);
 *      }
 *   });
 */

/** 
* Предоставляет работу со списками объектов. 
* Например, получить список отфильтрованных объектов – задач, заданий и уведомлений в проводнике, выделить объекты в списке закладок, 
* снять выделение с элементов табличной части справочника.
*
* @class WebAccess.components.wrappers.objectList.ObjectList
* @property {string} containerSelector Блок, содержащий список
* @property {string} objectSelector Элемент списка
* @fires WebAccess.components.wrappers.objectList.ObjectList#onSelect Вызывается после того, как был выбран объект из списка
* @fires WebAccess.components.wrappers.objectList.ObjectList#onChange Вызывается после внесения изменений в состав списка
* @since 5.0.0.4102
*/

(function (global) {


  var ObjectList = BaseObject.extend({
    className: 'ObjectList',

    init: function (containerSelector) {
      this._super(containerSelector);

      this.containerSelector = containerSelector + ' #main_container';
      this._jMainContainer = $(this.containerSelector);

      this._setupBindings();
      this._getType();

      this.getItems();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    containerSelector: "",
    objectSelector: ".List",
    _isAllSelected: false,
    _items: {},
    _jMainContainer: null,
    _jSearchTarget: null,
    _isTable: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить произвольное содержимое вместо текущего списка объектов.
    *
    * @method WebAccess.components.wrappers.objectList.ObjectList.setHtml
    * @return {WebAccess.components.wrappers.objectList} Специальный deferred-объект.
    */
    setHtml: function (html) {
      this._jMainContainer.html('<div id="object_list_padding">' + html + '</div>');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить элементы списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.getItems
     * @comment Keit_B: в справке не нашла. Пока не трогаю.
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    getItems: function () {
      var me = this;
      var items = {};

      me._jSearchTarget = me._jMainContainer.find(me.objectSelector);
      if (me._isTable) me._jSearchTarget = me._getItemsElementsinTable(me._jSearchTarget);

      for (var i = 0, l = me._jSearchTarget.length; i < l; i++) {
        var obj;
        var searchTarget = me._jSearchTarget[i];
        var jSearchTarget = $(searchTarget);
        if (jSearchTarget.hasClass('Task_obj') || jSearchTarget.hasClass('Job_obj'))
          obj = new global.components.wrappers.objectList.CustomWorkListItem(searchTarget, me._isTable);
        else
          obj = new global.components.wrappers.objectList.ListItem(searchTarget, me._isTable);

        if (obj.id) items[obj.id] = obj;
      };

      me._items = items;
      return items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    isAllItemsSelected: function () {
      return !!WA.CR.objectList && WA.CR.objectList._isAllSelected;
    },

    /**
     * Получить объекты списка, отфильтрованные селектором.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.getFilteredItems        
     * @return {WebAccess.components.wrappers.objectList.ListItem[]} Специальный deferred-объект.
     */
    getFilteredItems: function (filterSelector) {
      var me = this;
      var items = me._jMainContainer.find(me.objectSelector);

      if (filterSelector !== '') items = items.filter(filterSelector).filter(':not(.movedItem)');
      if (me._isTable) items = me._getItemsElementsinTable(items);

      var filteredItems = [];
      for (var i = 0; i < items.length; i++) {
        var newItem = me._getItemIdByjObject(items.eq(i));
        if (!!newItem) filteredItems.push(newItem);
      };

      return filteredItems;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    removeItems: function (links, opt_needUpdateTree) {
      var selector;
      var needUpdateTree = false || opt_needUpdateTree === true;
      $.each(links, function (_, l) {
        selector = format('#{0}.folder_item', l.id);
        if (links && links[0] && links[0].type && links[0].type === OBJECT_TYPE.ANY) {
          selector = '.folder_item';
        };

        var linkKind = l.kind ? l.kind.toLowerCase() : objectTypeToString(l.type).toLowerCase();
        $(selector).each(function () {
          var me = $(this);
          var elementKind = me.attr('kind').toLowerCase();

          if (elementKind == linkKind || linkKind == 'any') {
            if (elementKind == 'job' || elementKind == 'task' || elementKind == 'fol') needUpdateTree = true;
            me.remove();
          }
        });
      });

      if (needUpdateTree) {
        WA.CR.folderTree.update(function() {
          document.title = WA.CR.folderTree.getCurrentFolderName();
        });
      }
    },

    /**
     * Получает выделеннные элементы списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.getSelectedElements        
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    getSelectedItems: function () {
      return this.getFilteredItems('.selected');
    },

    /**
     * Выделить все объекты списка с учетом настройки "Папки в списке".
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
     * @return {WebAccess.current.objectList}
     */
    selectAll: function () {
      this._isAllSelected = false;
      if (WA.CR.objectList.isShowFolders()) {
        this._isAllSelected = true;
      }
      this._setCheckedForFilteredItems(':not(.selected)', true);
      HideTopSpinner(L("ITEMS_SELECETED", WA.CR.objectList.getSelectedItems().length));
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Выделить элемент списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
     * @return {WebAccess.current.objectList}
     */
    selectItemByID: function (id) {
      this._setCheckedForFilteredItems('#' + id + '.List', true);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Выделить элемент списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
     * @return {WebAccess.current.objectList}
     */
    selectItem: function (link) {
      this.selectItemByID(link.id);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Снять выделение со всех элементов списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.deselectAll
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    deselectAll: function () {
      this._isAllSelected = false;
      this._setCheckedForFilteredItems('.selected', false);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Снять выделение или, напротив, выделить все объекты списка в зависимости от их текущего состояния.
    *
    * @method WebAccess.components.wrappers.objectList.ObjectList.toggleAll      
    * @return {WebAccess.current.objectList} Специальный deferred-объект.
    */
    toggleAll: function () {
      if (!$("#chkAll").prop('checked')) { this.deselectAll(); }
      else this.selectAll();
      $("#scroller").redraw();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инвертировать выделение всех объектов списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.invertSelection
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    invertSelection: function () {
      var jCheckedItemsLength = this._jSearchTarget.filter(".selected").length;
      // Если небыло ничего выбранно и нажали на инвертировать выделение, то выделяем все.
      this._isAllSelected = (jCheckedItemsLength === 0);
      this._setCheckedForFilteredItems('', 'toggle');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает или снимает выделение с элементов списка, отфильтрованных filterSelector.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._setCheckedForFilteredItems
     * @private
     */
    _setCheckedForFilteredItems: function (filterSelector, isChecked) {
      var me = this;
      var items = me._jMainContainer.find(me.objectSelector);

      if (filterSelector !== '') items = items.filter(filterSelector);

      if (me._isTable) items = me._getItemsElementsinTable(items);

      for (var i = 0; i < items.length; i++) {
        var jListBox = items.eq(i);
        var chk = jListBox.find('input:first');
        if (isChecked === 'toggle') {
          chk.attr('checked', chk.is(':checked'));
        } else {
          chk.attr('checked', isChecked);
        }
        ToggleItem(chk);
        jListBox.redraw();
      }
      UpdateSelectionNumbers();
      me.fire('onSelect', me._getItemIdByjObject(items.last()), me.getFilteredItems('.selected'));
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Тип списка: таблица или нет.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._getType
     * @private
     * @return {boolean}
     */
    _getType: function () {
      return this._isTable = this._jMainContainer && this._jMainContainer.attr('class') && this._jMainContainer.attr('class').indexOf('slickgrid') !== -1;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установка событий, при кликах на чекбоксы. Чтобы срабатывали глобальные события.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._setupBindings
     * @private
     * @return {WebAccess.current.objectList}
     */
    _setupBindings: function () {
      var me = this;
      this.bind('itemsChange', function () {
        me._onItemsChanged();
      });

      this.bind('itemSelect', function (item) {
        item.isChecked = true;
        me._onItemSelected(item);
      });

      this.bind('itemUnSelect', function (item) {
        item.isChecked = false;
        me._isAllSelected = false;
        me._onItemSelected(item);
      });

      Core.toolBars.main.enableCheckBoxOnItemsSelect();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * При AJAX автоподгрузке элементов, надо обновлять список объектов.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemsChanged
     * @private
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    _onItemsChanged: function () {
      var me = this;
      me._jMainContainer = $(me.containerSelector);
      var items = me.getItems();
      me.fire("onChange", me.getFilteredItems('.selected'), items);
      return items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//1

    /**
     * При клике на чекбокс, вызовем свое событие.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemSelected
     * @private        
     * @return {WebAccess.current.objectList}
     */
    _onItemSelected: function (item) {
      this.fire('onSelect', item, this.getFilteredItems('.selected'));
      return this;
    },

    /**
     * Получает элементы списка отфильтрованные селектором.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemSelected
     * @private        
     * @return {WebAccess.components.wrappers.objectList.ListItem}
     */
    _getItemIdByjObject: function (jObject) {
      var id = this._isTable ? jObject.data('recid') : jObject.attr('id');
      return this._items[id];
    },

    /**
     * Получает элементы таблицы.
     * @method WebAccess.components.wrappers.objectList.ObjectList._getItemsElementsinTable
     * @private        
     * @return {jQuery}
     */
    _getItemsElementsinTable: function (items) {
      return items.not(".dxgvSelectedRow").not('.dxgvGroupRow').not('.dxgvEmptyDataRow');
    }

  });

  global.CMP.wrappers.objectList.ObjectList = ObjectList;

})(window.WebAccess);